import { useMutation } from '@apollo/client';
import { graphql } from 'gql.tada';

const UpdatePersonMutation = graphql.persisted(
  "UpdatePerson",
  graphql(`
    mutation UpdatePerson($input: UpdatePersonInput!) {
      updatePerson(input: $input) {
        person {
          id
          firstName
          lastName
          email
          phone
          gender
          dateOfBirth
        }
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { UpdatePersonMutation };

export function useUpdatePersonMutation() {
  return useMutation(UpdatePersonMutation);
}
